import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-20 bg-cream" data-id="element-112">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl text-navy/80 leading-relaxed" data-id="element-114">
          <p data-id="element-115">
            Pasas el día saltando de café en café, intentando forzar una
            concentración que no llega. Llegas al final de la jornada agotada,
            pero con la sensación de no haber avanzado nada real.
          </p>
          <p data-id="element-116">
            El estrés de las entregas, la mala alimentación "al paso" y el
            bombardeo constante de notificaciones han creado un cortocircuito en
            tu capacidad de enfoque. Si no detienes este ciclo, el agotamiento
            (burnout) no es una posibilidad, es una certeza.
          </p>
        </motion.div>
      </div>
    </section>;
}